export enum Permission {
  InventoryFileCollectionMapping = 'inventory_file_collection_mapping.modify',
  AdminPanel = 'admin_panel.legacy_permission',
}
